/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_BodybuildingInputs */

const en_us2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bodybuilding`)
};

const pt_br2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisiculturismo`)
};

const es_419_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fisicoculturismo`)
};

const pt_pt2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Culturismo`)
};

const fr_fr2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Culturisme`)
};

const de_de2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bodybuilding`)
};

const it_it2_modality_bodybuilding = /** @type {(inputs: Modality_BodybuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Culturismo`)
};

/**
* | output |
* | --- |
* | "Bodybuilding" |
*
* @param {Modality_BodybuildingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_bodybuilding = /** @type {((inputs?: Modality_BodybuildingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_BodybuildingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_bodybuilding(inputs)
	if (locale === "es-419") return es_419_modality_bodybuilding(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_bodybuilding(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_bodybuilding(inputs)
	if (locale === "de-DE") return de_de2_modality_bodybuilding(inputs)
	if (locale === "it-IT") return it_it2_modality_bodybuilding(inputs)
	return en_us2_modality_bodybuilding(inputs)
});
export { modality_bodybuilding as "modality.bodybuilding" }